import React from 'react'
export default class extends React.Component {
	render() {
		return <div>123</div>
	}
}



// WEBPACK FOOTER //
// ./src/modules/modeling/Designer.tsx